import React from 'react';
import PropTypes from 'prop-types';
import autobind from "autobind-decorator";
import { connect } from 'react-redux';

import { PureComponent, InfiniteScroll } from 'core/components';
import { Row, Icon, Col } from 'core/components/Framework7';
import { addToCart, changeCountItem, deleteItem } from 'content/pages/Cart/Module';
import { ProductItem } from 'content/components';

import classes from './styles.module.css';

class ProductList extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  rendeList() {
    const { items } = this.props;

    // if (!items || items.length === 0) return this.renderEmpty();

    // TODO remove index from map
    return items.map(item => {
      return this.renderItem(item)
    })
  }

  renderEmpty() {
    return (
      <Col width="100" className={classes.empty}>
        <Icon icon="mdi-basket" />
        <div className={'product-list-empty'}>{'مشتری گرامی'}<br />{'با تشکر از همراهی و صبوری شما، کالاهای این دسته به زودی معرفی می گردد.'}</div>
      </Col>
    )
  }

  renderItem(item) {
    const { img, navigate } = this.props;

    return (
      // TODO return back key={id} to key={item.id}
      <div
        key={item.id}
        className={`${classes.productItem} col-auto`}
        // Just use style for fast rendering
        style={{ '--f7-cols-per-row': 'var(--list-cols-per-row)' }}
      >
        <ProductItem
          item={item}
          img={img}
          navigate={navigate}
        />
      </div>
    )
  }

  loadMore(...rest) {
    this.props.loadMore && this.props.loadMore(...rest)
  }

  render() {
    const { hasNext, loadingMore, loading, onScroll, className, initialLoad } = this.props;

    return (
      <InfiniteScroll
        type="flex"
        className={`${classes.root} ${className} page-bottom-padding`}
        hasMore={hasNext}
        loadMore={this.loadMore}
        loading={loadingMore || loading || initialLoad}
        offset={250}
        initialLoad={false}
        onScroll={onScroll}
      >
        <Row className={classes.container}>
          {/* {false && <Col width="100" className={classes.preloader}><Preloader></Preloader></Col>} */}
          {!initialLoad && this.rendeList()}
        </Row>
      </InfiniteScroll>
    )
  }
}

ProductList.propTypes = {
  items: PropTypes.array,
};

export default connect(
  state => ({
    cart: state.Cart.cart
  }),
  {
    addToCart,
    changeCountItem,
    deleteItem
  }
)(autobind(ProductList));
